import * as React from "react";

import {
  useDebugPublishStatusOverride,
  useDebugPublishStatusOverrideActions,
} from "@v2/features/debug/debugPublishStatusOverrideStore";

const DebugPublishStatusOverrideBanner: React.FC = () => {
  const override = useDebugPublishStatusOverride();
  const { clearPublishStatusOverride } = useDebugPublishStatusOverrideActions();

  if (!override) {
    return null;
  }

  return (
    <div className="bg-sky-soft absolute top-0 left-0 z-max flex w-full items-center justify-center gap-2 p-2.5 text-center text-xs font-bold text-sky pointer-events-auto">
      <span>Debug: Publish status overridden to [{override.status}]</span>
      <button
        type="button"
        className="rounded bg-sky-soft px-1.5 py-0.5 text-[10px] font-medium text-sky hover:opacity-80"
        onClick={clearPublishStatusOverride}
      >
        Clear
      </button>
    </div>
  );
};

export default DebugPublishStatusOverrideBanner;
